import { Session } from "next-auth"
import logger from "@/lib/logger"

export function isSessionExpired(session: Session | null): boolean {
  if (!session || !session.expires) {
    return true
  }

  const now = new Date()
  const expiresAt = new Date(session.expires)
  const isExpired = now >= expiresAt

  if (isExpired) {
    logger.info(`Session expired. Expires: ${expiresAt}, Now: ${now}`)
  }

  return isExpired
}

export function isSessionExpiringSoon(session: Session | null): boolean {
  if (!session || !session.expires) {
    return true
  }

  const now = new Date()
  const expiresAt = new Date(session.expires)
  const timeUntilExpiry = expiresAt.getTime() - now.getTime()

  return timeUntilExpiry <= 5000
}

export function getSessionTimeRemaining(session: Session | null): number {
  if (!session || !session.expires) {
    return 0
  }

  const now = new Date()
  const expiresAt = new Date(session.expires)
  const timeRemaining = expiresAt.getTime() - now.getTime()

  return Math.max(0, timeRemaining)
}
